import ProberEvent from './ProberEvent'
import {PROBER_EVENT_TIMING} from './ProberEventTypes'

export default class TimingEvent extends ProberEvent {
  constructor(category, action, time) {
    super({
      category,
      action,
      time,
    })
    this.data.type = PROBER_EVENT_TIMING
  }
}
